import Vue from "vue";
import Router from "vue-router";
import store from ".././vuex/store";
import routers from "./routers";
import { Notify } from "vant";
import Bridge from ".././vuex/bridge.js";
import {
    LOGOUT,
    LOGIN
} from "@/vuex/mutation_types";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

Vue.use(Router);

const router = new Router({
    mode: 'history',  // 正式需打开history,测试注掉
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) { //如果savedPosition存在，滚动条会自动跳到记录的值的地方
            return savedPosition;
        } else {
            return { x: 0, y: 0 };//savedPosition也是一个记录x轴和y轴位置的对象
        }
    },
    routes: routers
});

/**
 * role 0 为普通用户，目前没有其他角色；
 * keepAlive 为是否缓存页面，默认为false 不缓存
 */

// 导航钩子，全局钩子
router.beforeEach((to, from, next) => {
    // console.log("to", to);
    // console.log("from", from);
	if(to.name == 'home' && to.query.back == 'cangpin'){
		window.open(Vue.prototype.$publicData.cangpinUrl);
		return;
	};
    if (to.meta.title) {
        window.document.title = to.meta.title;
    }
    // 给匠人的合作伙伴 动态设置title
    if (store.getters.token != "" && to.name == "tradesman-partner") {
        if (to.query.status == 1) {
            window.document.title = "我的城市合伙人";
        }
    }

    // 结算页后退
    var shopSettleFun = function(e) {
        // alert("我监听到了浏览器的返回按钮事件啦");//根据自己的需求实现自己的功能
        console.log(from.name);
        var createOrder = window.localStorage.getItem("createOrder");
        console.log(createOrder);
        if (
            from.name == "shop-pay" &&
            (to.name == "shop-settle" || to.name == "dingzhi-settle") &&
            createOrder != undefined &&
            createOrder != null
        ) {
        }
        return;
    };
    window.addEventListener("popstate", shopSettleFun(), true);
    if (to.name == 'shop-pay' && to.query && to.query.from == 'number') { // 文旅跳转过来的支付页 重置token
        if (to.query.token && to.query.token != undefined && to.query.token != '') {
			store.commit(LOGIN,{
				token: to.query.token
			})
        }
    };
	// 数字藏品跳转过来的支付页 重置token
	if (to.name == 'yuekan-pay' && to.query && to.query.type == 'cangpin') { 
        if (to.query.token && to.query.token != undefined && to.query.token != '') {
			store.commit(LOGIN,{
				token: to.query.token
			})
        }
    };
	// 数字藏品跳转过来绑微信的 重置token
	// if(to.name == 'cangpin-account' && to.query && to.query.type == 'cangpin'){
	// 	if (to.query.token && to.query.token != undefined && to.query.token != '') {
	// 		store.commit(LOGIN,{
	// 			token: to.query.token
	// 		})
    //     }
	// };
    // 未登录 请先登录
    if (store.getters.token === "" && to.meta.requiresAuth) {
        // Notify('请先登录');
        // next('/home/index')
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            //获取用户信息
            var memberParams = {
                data: {},
            };
            setupWebViewJavascriptBridge(function(bridge) {
                bridge.callHandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            next();
                        }
                    }
                );
            });
        } else {
            localStorage.setItem("redirect", to.fullPath);
            next("/login")
        }
	} else if(store.getters.token != "" && to.name == "reapal-index"){
		next('/pay/index')
	}else if (store.getters.token != "" && to.name == "login") {
        next(from.path);
	} else {
        // console.log('to====',to)
        next();
    }
});
router.afterEach((to) => {});
function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
}
export default router;
